export default {
	title: 'إضافة مهمة',

	addMission: {
		forDay: 'يومية',
		forHour: 'ساعية',
		withSalary: 'مع راتب',
		withOutSalary: 'بلا راتب',
		noSalary: 'بلا راتب',
		type: 'النوع',
		time: 'الوقت',
		cause: 'السبب',
		duration: 'المدة',
	}
};
